module.exports = __webpack_public_path__ + "img/ic_add file_1.a65aad15.svg";